import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  // Flex,
  // Heading,
  Text,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  FormErrorMessage,
  VStack,
  Divider,
} from '@chakra-ui/react';
import { Formik, Form, Field } from 'formik';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
// import { BsExclamationCircle } from 'react-icons/bs';
import * as Yup from 'yup';
import SubscriptionStatus from './SubscriptionStatus';

// Validation schema
const validationSchema = Yup.object({
  currentPassword: Yup.string().required('Current password is required'),
  newPassword: Yup.string()
    .min(8, 'New password must be at least 8 characters')
    .required('New password is required'),
  confirmNewPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
    .required('Please re-enter your new password'),
});

function AccountForm({ plan }) {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

  // const plan = {
  //   subscriptionId: '1345678',
  //   interval: 'month',
  //   isFreePlan: true,
  //   status: 'Trialing',
  //   trialEndDate: '11-03-2024',
  //   nextBillingTime: '12-03-2024',
  //   expiredDate: null,
  //   price: '9.99',
  //   interval: 'month',
  //   discountInfo: '',
  // };

  const getPlanName = (interval) => {
    if (interval == 'month') return 'Pro Monthly Plan';
    if (interval == 'year') return 'Pro Yearly Plan';
    return '';
  };

  const toggleCurrentPassword = () =>
    setShowCurrentPassword(!showCurrentPassword);
  const toggleNewPassword = () => setShowNewPassword(!showNewPassword);
  const toggleConfirmNewPassword = () =>
    setShowConfirmNewPassword(!showConfirmNewPassword);

  return (
    <>
      <Text fontSize="md" fontWeight="bold">
        Password
      </Text>
      <Formik
        initialValues={{
          currentPassword: '',
          newPassword: '',
          confirmNewPassword: '',
        }}
        validationSchema={validationSchema}
        onSubmit={() => {
          // console.log('Form submitted with values:', values);
        }}
      >
        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Box
              // border="1px"
              // borderRadius="md"
              // boxShadow="md"
              // p={6}
              // maxWidth="400px"
              width="100%"
              mx="auto"
              mt={2}
            >
              <VStack spacing={4}>
                {/* Current Password Field */}
                <Field name="currentPassword">
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={
                        form.errors.currentPassword &&
                        form.touched.currentPassword
                      }
                    >
                      <FormLabel>Current Password</FormLabel>
                      <InputGroup>
                        <Input
                          {...field}
                          type={showCurrentPassword ? 'text' : 'password'}
                          placeholder="Enter current password"
                        />
                        <InputRightElement>
                          <Button
                            size="sm"
                            onClick={toggleCurrentPassword}
                            variant="ghost"
                          >
                            {showCurrentPassword ? (
                              <ViewOffIcon />
                            ) : (
                              <ViewIcon />
                            )}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                      <FormErrorMessage>
                        {form.errors.currentPassword}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                {/* New Password Field */}
                <Field name="newPassword">
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={
                        form.errors.newPassword && form.touched.newPassword
                      }
                    >
                      <FormLabel>New Password</FormLabel>
                      <InputGroup>
                        <Input
                          {...field}
                          type={showNewPassword ? 'text' : 'password'}
                          placeholder="Enter new password"
                        />
                        <InputRightElement>
                          <Button
                            size="sm"
                            onClick={toggleNewPassword}
                            variant="ghost"
                          >
                            {showNewPassword ? <ViewOffIcon /> : <ViewIcon />}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                      <FormErrorMessage>
                        {form.errors.newPassword}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                {/* Confirm New Password Field */}
                <Field name="confirmNewPassword">
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={
                        form.errors.confirmNewPassword &&
                        form.touched.confirmNewPassword
                      }
                    >
                      <FormLabel>Re-enter New Password</FormLabel>
                      <InputGroup>
                        <Input
                          {...field}
                          type={showConfirmNewPassword ? 'text' : 'password'}
                          placeholder="Re-enter new password"
                        />
                        <InputRightElement>
                          <Button
                            size="sm"
                            onClick={toggleConfirmNewPassword}
                            variant="ghost"
                          >
                            {showConfirmNewPassword ? (
                              <ViewOffIcon />
                            ) : (
                              <ViewIcon />
                            )}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                      <FormErrorMessage>
                        {form.errors.confirmNewPassword}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Button
                  type="submit"
                  colorScheme="green"
                  alignSelf="flex-start"
                >
                  Update Password
                </Button>
              </VStack>
            </Box>
          </Form>
        )}
      </Formik>
      <Divider mt={4} mb={4} />

      <Text fontSize="md" mb={2} fontWeight="bold">
        Subscriptions
      </Text>
      <SubscriptionStatus
        subscriptionId={plan.subscriptionId}
        isFreePlan={plan.isFreePlan}
        planName={getPlanName(plan.interval)}
        status={plan.status}
        trialEndDate={plan.trialEndDate}
        nextBillingTime={plan.nextBillingTime}
        expiredDate={plan.expiredDate}
        price={plan.price}
        interval={plan.interval}
        discountInfo={plan.discountInfo}
      />
    </>
  );
}

AccountForm.propTypes = {
  plan: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number])
  ),
};

export default AccountForm;
